import dayjs from 'dayjs';
import shortUUID from 'short-uuid';

import { isOverallApartmentType } from './apartmentTypes';
import { OccupancyDataType } from '../../components/CommunityInfo/careTypes/types';
import { GLOBAL_DATE_FORMAT } from '../../constants';
import { average, sum } from '../helpers/numbers';

export const getOccupancyPercentageAggregate = (data: OccupancyDataType[]) => {
  const overallEntries: OccupancyDataType[] = [];
  const roomTypeEntries: OccupancyDataType[] = [];

  data?.forEach((item: OccupancyDataType) => {
    if (isOverallApartmentType({ id: item.apartment_type_id })) {
      overallEntries.push(item);
    } else {
      roomTypeEntries.push(item);
    }
  });

  const hasOverallEntry = Boolean(overallEntries.length);

  const entries = hasOverallEntry ? overallEntries : roomTypeEntries;
  const entriesFiltered = entries
    .filter(
      (item: OccupancyDataType) =>
        (item.total_apartments_units !== undefined && item.free_apartments_units !== undefined) || item.pct_occupancy
    )
    .map((item: OccupancyDataType) => ({
      totalUnits: item.total_apartments_units,
      freeUnits: item.free_apartments_units,
      occupancy: item.pct_occupancy
        ? Number(item.pct_occupancy)
        : ((item.total_apartments_units - item.free_apartments_units) / item.total_apartments_units) * 100,
    }));

  const totalUnits = sum((entriesFiltered ?? []).map((item: any) => item.totalUnits));
  const freeUnits = sum((entriesFiltered ?? []).map((item: any) => item.freeUnits));
  const occupancy = average((entriesFiltered ?? []).map((item: any) => item.occupancy));

  const hideUnitsRatio = entries.some(
    (item: any) =>
      item.total_apartments_units === undefined ||
      item.total_apartments_units === null ||
      item.total_apartments_units === null ||
      item.free_apartments_units === undefined
  );

  return { totalUnits, freeUnits, occupancy, hideUnitsRatio };
};

export const mapCommunityOccupancyResponseToData = (item: any) => {
  return {
    id: item?.id,
    key: item ? String(item?.id) : shortUUID.generate(),
    apartmentType: item?.apartment_type,
    apartmentTypeId: item?.apartment_type_id,
    livingTypeId: item?.living_type_id,
    livingType: item?.living_type,
    totalApartmentsUnits: item?.total_apartments_units,
    freeApartmentsUnits: item?.free_apartments_units,
    occupancyPercentage: item?.pct_occupancy,
    createdBy: item?.created_by,
    createdAt: dayjs(new Date(item?.created_at).toDateString(), { format: GLOBAL_DATE_FORMAT }),
    updatedBy: item?.updated_by,
    updatedAt: dayjs(new Date(item?.updated_at).toDateString(), { format: GLOBAL_DATE_FORMAT }),
    date: dayjs(new Date(item?.date).toDateString(), { format: GLOBAL_DATE_FORMAT }),
  };
};
